/**
 * date：2022-02-24
 * author：brian
 * purpose：基于屎山(哈哈哈)代码的一次共用数据，因在维护期需要替换所有的页面搜索组件的集成，而search组件所需要的init参数基本一致 所以考录用混入来方便操作
 */

const mixin = {
    data() {
        return {
            SearchForm: {
                iDisplayStart: 0,
                iDisplayLength: 15
            },
            total: 0,
            loading: false,
            tableData: [],
            title:'',
            isShow:false
        }
    },
    mounted() {
        this.getListFn();
    },
    methods: {
        resetFn() {
            this.SearchForm = {
                iDisplayStart: 0,
                iDisplayLength: 15
            }
            this.getListFn();
        }
    }
}

export default mixin